/* eslint-disable @typescript-eslint/dot-notation */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-share-on-web',
  templateUrl: './share-on-web.component.html',
  styleUrls: ['./share-on-web.component.scss'],
})
export class ShareOnWebComponent implements OnInit {

  @Input() public shareData: any;

  constructor(
    public navController: NavController,
    public modalController: ModalController,
  ) { }

  ngOnInit() {
    console.log(this.shareData);
  }
copyToClipboard(){
  navigator.clipboard.writeText(this.shareData.url);
}

  closeModal() {
    this.modalController.dismiss();
  }

}
